



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class SideBarGroup extends Vue {
  @Prop() public title!: string;
  @Prop() public accordion!: string;

  //sidebar.vueから直接お気に入りメニューを追加するためのプロパティ
  @Prop() public to!: string;
  @Prop({ default: null }) public perm: string;
  @Prop({ default: null }) public icon: string;
  @Prop({ default: null }) public svg: string;  
  @Prop({ default: 0 }) public indent: number;
  @Prop({ default: '#495057' }) public iconColor: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:null}) public count: number;
  @Prop() public query: string;  //クエリ

  public items: Common.Favorite[] = new Array(0);
  
  public opened: boolean = false;
  public arrowIcon: string = 'arrow_right';

  public mounted(){
    if (this.$route.fullPath == this.to){
      this.$nextTick(()=>this.selected());
    }
  }
  public apend(item: Components.SideBarItem){
    //グループ内にターゲットがある場合はオープンすうｒ。
    if (this.$route.fullPath == item.to){
      // this.$nextTick(()=>this.collapse());
      this.$emit('selected', this);
    }
  }
  public isEditable(item: Common.Favorite){
    return item.isTenant == false || this.$api.perms.hasMenuPermission(Common.Favorite.perm);
  }
  @Watch('opened')
  public onValueChange(newValue: boolean, oldValue: boolean): void {
    if (this.opened) {
      this.arrowIcon = 'arrow_drop_down';
    } else {
      this.arrowIcon = 'arrow_right';
      //クエリパラメータを除外して一致している場合は、リダイレクトする
      if (this.to != this.$route.fullPath && this.to == this.$route.path) {
        this.$router.push(this.to);
      }
    }
  }
  
  public getPath(index: number) {
    const item = this.items[index];
    return item.path + '?favorite=' + item.key + '&static=1';
  }

  public selected() {
      this.$emit('selected', this);
  }

  public collapse() {
    this.opened = !this.opened;
    if (this.opened) {
      this.arrowIcon = 'arrow_drop_down';
    } else {
      this.arrowIcon = 'arrow_right';
    }
  }

  // public favorite : Common.Favorite;
  // public showFavorite:boolean = false;
  // public onEditFavorite(to:string) {
  //   this.favorite = this.items.find(item =>item.path + '?favorite=' + item.key + '&static=1' == to );
  //   this.favorite = this.favorite.binder.loadInstance(this.favorite); //クローン
  //   this.showFavorite = true;
  // }
  // public execFavorite(){
  //   //更新する
  //   this.$api.update(this.favorite);
  //   var index = this.items.findIndex(item => item.id == this.favorite.id);
  //   this.items[index] = this.favorite;    
  // }

  public onDelete(to : string){
    var target = this.items.find(item =>item.path + '?favorite=' + item.key + '&static=1' == to );
    this.$api.modal.showDialog('確認',String.format('お気に入り「{0}」を削除してよろしいですか?',target.name),false).then(()=>{
            
      this.$api.remove(target).then(()=>this.reload()).then(()=>this.$router.push(this.to));      
    });
  }



  private sourceId:number;
  private targetId:number = -1;
  public dragStart(index: number, e: any) {
    e.dataTransfer.effectAllowed = "move";
    this.sourceId = index;
    this.targetId = -1;
  }
  public dragOver(index: number, e: any) {
    if (e.preventDefault) e.preventDefault(); // Necessary. Allows us to drop.
    e.dataTransfer.dropEffect = 'move'; // See the section on the DataTransfer object.

    //スタートセルとの相対関係でドロップ境界を判定する
    const source = this.items[this.sourceId];
    const target = this.items[index];

    if (index == this.sourceId || source.isTenant != target.isTenant) this.targetId = -1;
    else if (index > this.sourceId) this.targetId = index + 1;
    else this.targetId = index;
    return false;
  }
  public drop(index: number, e: any) {     

    const source = this.items[this.sourceId];
    const target = this.items[index];
    this.targetId = -1;

    if(source.isTenant == target.isTenant && source.displayOrder != target.displayOrder && target.displayOrder >0)  {
      this.$api.execute(new Common.RowSequenceUpdateQuery(source,target.displayOrder)).then(()=>{
        this.reload();
      });
    }
  }    

  public dragleave(){
    this.targetId = -1;
  }

  public  async reload(){
    this.$api.execute(new Common.FavoriteQuery(Common.favoriteFlags.All,this.to))
    .then(res =>{
      //カウントをコピーする
      this.items.forEach(item => {
        var reloaded = (res.result as Array<Common.Favorite>).find(obj =>obj.id == item.id);
        if (reloaded) reloaded.count = item.count;
      });
      this.items = res.result;
      this.$forceUpdate();
      return Promise.resolve();
      });
  }
}
